// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FrownFilledSvg from "@fishx/icons-svg/es/asn/FrownFilled";
import FishxIcon from '../components/FishxIcon';

var FrownFilled = function FrownFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: FrownFilledSvg
  }));
};

FrownFilled.displayName = 'FrownFilled';
export default React.forwardRef(FrownFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/FrownFilled.js
// module id = 2836
// module chunks = 0